import { render, staticRenderFns } from "./DSFileUploadArea.vue?vue&type=template&id=28f107d8&scoped=true&"
import script from "./DSFileUploadArea.vue?vue&type=script&lang=ts&"
export * from "./DSFileUploadArea.vue?vue&type=script&lang=ts&"
import style0 from "./DSFileUploadArea.vue?vue&type=style&index=0&id=28f107d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f107d8",
  null
  
)

export default component.exports